@if (canUse) {
  <div class="little-tiff-root" #root [class.little-tiff-dragging]="isDragging"
       [style.left.px]="left" [style.top.px]="top" [style.right]="left === null ? '16px' : 'auto'">
    @if (isOpen) {
      <div class="little-tiff-panel" role="dialog" aria-label="Little Tiff assistant"
           [class.little-tiff-panel-below]="panelBelow" [class.little-tiff-panel-align-left]="panelAlignLeft"
           [style.height.px]="panelMaxHeight">
        <div class="little-tiff-header" (pointerdown)="onPointerDown($event)">
          <img class="little-tiff-header-avatar" src="assets/little-tiff-avatar.png" alt="" aria-hidden="true" />
          <div class="little-tiff-header-text">
            <h2>Little Tiff</h2>
            <p>HR Portal helper</p>
          </div>
          <button type="button" class="little-tiff-close" (click)="toggle()" aria-label="Close">&times;</button>
        </div>

        <div class="little-tiff-toolbar">
          @if ((status?.models?.length || 0) > 1) {
            <select [(ngModel)]="selectedModelId" [disabled]="isLoading" aria-label="Model">
              @for (model of status?.models; track model.modelId) {
                <option [value]="model.modelId">{{ model.displayName || model.modelId }}</option>
              }
            </select>
          }
          <button type="button" class="little-tiff-link-button" (click)="clearHistory()" [disabled]="isLoading || messages.length === 0">
            Clear context
          </button>
          <span class="little-tiff-status" aria-live="polite">{{ statusMessage }}</span>
        </div>

        <div class="little-tiff-messages" #messagesContainer>
          @if (messages.length === 0) {
            <div class="little-tiff-welcome">
              Hi! Ask me where to find something in the HR Portal or how to do a task, such as requesting time off or signing a document.
            </div>
          }
          @for (message of messages; track $index) {
            <div class="little-tiff-message" [class.user]="message.role === 'user'" [class.assistant]="message.role === 'assistant'">
              <div class="little-tiff-bubble">{{ message.text }}</div>
              @if (message.steps?.length) {
                <ol class="little-tiff-steps">
                  @for (step of message.steps; track $index) {
                    <li>{{ step }}</li>
                  }
                </ol>
              }
              @if (message.warnings?.length) {
                <ul class="little-tiff-warnings">
                  @for (warning of message.warnings; track $index) {
                    <li>{{ warning }}</li>
                  }
                </ul>
              }
              @if (message.actions?.length) {
                <div class="little-tiff-actions">
                  @for (action of message.actions; track $index) {
                    <button type="button" class="little-tiff-action-btn" [title]="action.reason || ''" (click)="openAction(action)">
                      {{ action.label || 'Open' }}
                    </button>
                  }
                </div>
              }
              @if (message.feedback) {
                <div class="little-tiff-feedback">
                  @if (!message.feedbackSaved) {
                    <button type="button" class="little-tiff-link-button" (click)="submitFeedback(message, 'good')">
                      <i class="pi pi-thumbs-up" aria-hidden="true"></i> Good
                    </button>
                    <button type="button" class="little-tiff-link-button" (click)="message.showCorrection = !message.showCorrection">
                      <i class="pi pi-thumbs-down" aria-hidden="true"></i> Wrong
                    </button>
                    @if (message.showCorrection) {
                      <textarea rows="3" maxlength="4000" [(ngModel)]="message.correction" placeholder="What should Little Tiff have answered?"></textarea>
                      <button type="button" class="little-tiff-action-btn" (click)="submitFeedback(message, 'wrong')">Save correction</button>
                    }
                  }
                  <span class="little-tiff-status">{{ message.feedbackStatus }}</span>
                </div>
              }
            </div>
          }
          @if (isLoading) {
            <div class="little-tiff-loading">Thinking...</div>
          }
        </div>

        <div class="little-tiff-input-area">
          <textarea rows="2" maxlength="2000" [(ngModel)]="input" (keydown)="onInputKeydown($event)"
                    placeholder="e.g. How do I request time off?" aria-label="Question"></textarea>
          <button type="button" class="little-tiff-send" (click)="send()" [disabled]="isLoading || !hasModels || !input.trim()">Send</button>
        </div>
      </div>
    }

    <button type="button" class="little-tiff-toggle" (pointerdown)="onPointerDown($event)" (click)="onToggleClick()"
            [attr.aria-expanded]="isOpen" title="Little Tiff - drag to move, click to open">
      <img src="assets/little-tiff-avatar.png" alt="Little Tiff" />
      <span class="little-tiff-toggle-label">Little Tiff</span>
    </button>
  </div>
}
